<template>
    <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 566.918 566.918" 
         class="fill-current"
         :class="`h-${size ? size : '5'} w-${size ? size : '5'}`">

        <path d="M538.411,254.964h-23.299c-12.98-106.019-97.149-190.187-203.16-203.158V28.505C311.952,12.758,299.194,0,283.448,0
			c-15.747,0-28.505,12.758-28.505,28.505v23.299c-106,12.991-190.15,97.139-203.141,203.141H28.505
			C12.768,254.946,0,267.705,0,283.452c0,15.735,12.758,28.505,28.505,28.505h23.299c12.97,106.008,97.13,190.168,203.141,203.158
			v23.297c0,15.748,12.758,28.506,28.505,28.506c15.745,0,28.504-12.758,28.504-28.506v-23.297
			c106.011-12.972,190.18-97.131,203.16-203.144h23.299c15.736,0,28.505-12.756,28.505-28.504
			C566.916,267.732,554.157,254.964,538.411,254.964z M457.511,254.964l-73.19-0.006c-9.863-34.992-37.375-62.493-72.365-72.367
			v-73.183C386.472,121.574,445.338,180.439,457.511,254.964z M254.945,109.418v73.179c-34.98,9.874-62.483,37.375-72.347,72.359
			l-73.193-0.01C121.588,180.439,180.436,121.593,254.945,109.418z M109.407,311.958l73.193,0.008
			c9.861,34.98,37.365,62.48,72.347,72.357v73.18C180.426,445.33,121.58,386.476,109.407,311.958z M311.952,457.513v-73.182
			c34.99-9.873,62.494-37.375,72.365-72.365l73.19,0.008C445.338,386.492,386.481,445.347,311.952,457.513z"/>

    </svg>
</template>

<script>
export default {
  name: "SniperIcon",
  props: ['size'],
}
</script>

<style scoped>

</style>
